<div class="main-content" (window:resize)="onResize()">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">

                <div class="d-sm-flex align-items-center justify-content-between mb-4 margin-bottom breadcrumbsWrab">
                    <!--<h1 class="h3 mb-0 text-gray-800 assessments">Edit Client</h1>-->
                    <div class="breadcrumbs">
                        <span [routerLink]="['/app/clients']">Manage Clients</span> > <span class="active">{{client.firstName}} {{this.client.lastName}}</span>
                        <ng-container *ngIf="client.id != _Globals.getUserId()">
                            <a class="pointer" style="color: #1a33d7;"><i class="far fa-edit" (click)="showEditClientModal()"></i></a>
                            <a class="pointer" style="color: #1a33d7;"><i class="far fa-trash-alt" (click)="openConfirmationModal()"></i></a>
                        </ng-container>
                        <div class="emailSpace">
                            <div></div><p class="active">{{client.email}}</p>
                        </div>

                    </div>

                    <!--<div class="btns-container">-->
                    <!--<a  class="d-none d-sm-inline-block btn btn-sm shadow-sm margin-right-5 btn-red">
                        <i class="fas fa-trash text-white-50"> <span class="button-text"> Delete</span></i>
                    </a>-->
                    <!--<a (click)="updateClient()" class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm">
                        <i class="fas fa-plus text-white-50"> <span class="button-text"> Save</span></i>
                    </a>-->
                    <!--</div>-->
                </div>
                <br />

                <div>
                    <ng-container *ngIf="loading; else editClientContent">
                        <div *ngIf="loading" class="text-center" style="position: absolute;width: 99.8%;height: 100%;background-color: #fff;z-index: 3;min-height:300px;">
                            <i class="fa fa-spinner fa-pulse fa-3x fa-fw" style="color:#46a8ce; font-size: 75px;"></i>
                            <p>Loading, please wait...</p>
                        </div>
                    </ng-container>

                    <div>
                        <form id="shopifyForm" action="https://community.ipeccoaching.com/sso-eli-shopify/" method="post" enctype="multipart/form-data">
                            <input type="text" name="contact_id" value="" hidden>
                            <input type="email" name="user_email" value="" hidden>
                            <input type="text" name="first_name" value="" hidden>
                            <input type="text" name="last_name" value="" hidden>
                            <!--<input type="submit" value="SSO-Redirect" (click)="ssoToShopify()">-->
                        </form>
                    </div>

                    <div class="quickMenu" style="top: -54px;">
                        <div class="dropdown">
                            <a class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm" data-toggle="dropdown">
                                <span class="button-text"> Actions </span> <i class="fas fa-caret-down" style="vertical-align: unset;"></i>
                            </a>
                            <ul class="dropdown-menu">
                                <!--<li><a (click)="getUserPersonalData()">Purchase assessments</a></li>-->
                                <li><a href="https://ipec-single-sign-on.azurewebsites.net/api/saml/initiate-login?state=https://market.ipeccoaching.com/products/eli-self-assessment-1&code=8_haf_FvYLDXB1EDpw9MZF9vsLIs3yU2YISFLmXPJvUaAzFux01Cbw==" target="_blank">Purchase Self assessments</a></li>
                                <li><a href="https://ipec-single-sign-on.azurewebsites.net/api/saml/initiate-login?state=https://market.ipeccoaching.com/products/eli-360-assessment&code=8_haf_FvYLDXB1EDpw9MZF9vsLIs3yU2YISFLmXPJvUaAzFux01Cbw==" target="_blank">Purchase 360 assessments</a></li>
                                <li><a (click)="openAssignModal()">Assign assessments</a></li>
                            </ul>
                        </div>
                    </div>

                    <ng-template #editClientContent>
                        <div class="d-sm-flex align-items-center justify-content-between mb-4 customMainContainer">
                            <h1 class="h3 mb-0 text-gray-800 assessments"></h1>

                            <div class="btns-container">
                                <!--<div *ngIf="currentSelectedTab == 0 || currentSelectedTab == 0.2">
                    <div style="height:40px;"></div>
                </div>-->

                                <div *ngIf="currentSelectedTab == 1 || currentSelectedTab == 1.2">

                                    <a id="addTagsAssessments" (click)="openAddTagsAssessmentsModal()" [ngClass]="{'btn-primary': canAddTags, 'btn-gray': !canAddTags}" class="d-none d-sm-inline-block btn btn-sm  shadow-sm margin-right-5">
                                        <i class="fas fa-plus text-white-50"> <span class="button-text"> Add Tags</span></i>
                                    </a>

                                    <!--<a (click)="goToConversionRate()" *ngIf="currentSelectedTab == 1.2" id="conversionRate"
                       class="d-none d-sm-inline-block btn btn-sm shadow-sm margin-right-5" [ngClass]="{'btn-primary': _Globals.assignedCanConversionRate, 'btn-gray': !_Globals.assignedCanConversionRate}">
                        <i class="fas fa-table text-white-50"> <span class="button-text"> Conversion Rate</span></i>
                    </a>-->

                                    <a (click)="sendReminder()" id="sendReminder" class="d-none d-sm-inline-block btn btn-sm shadow-sm margin-right-5" [ngClass]="{'btn-primary': assignedCanSendReminder, 'btn-gray': !assignedCanSendReminder}">
                                        <i class="fas fa-send text-white-50"> <span class="button-text"> Resend Invitation</span></i>
                                    </a>
                                    <a (click)="openExtendModal('assigned')" class="d-none d-sm-inline-block btn btn-sm shadow-sm margin-right-5" [ngClass]="{'btn-primary': canUpdate, 'btn-gray': !canUpdate}">
                                        <i class="fas fa-calendar-day text-white-50"> <span class="button-text"> Update</span></i>
                                    </a>
                                    <a (click)="copy()" class="d-none d-sm-inline-block btn btn-sm  shadow-sm margin-right-5" [ngClass]="{'btn-other': canCopy, 'btn-gray': !canCopy}">
                                        <i class="fas fa-copy text-white-50"> <span class="button-text"> Copy link</span></i>
                                    </a>
                                    <a *ngIf="currentSelectedTab == 1.2" (click)="showRatersModal()" class="d-none d-sm-inline-block btn btn-sm shadow-sm margin-right-5" [ngClass]="{'btn-primary': canAddRaters, 'btn-gray': !canAddRaters}">
                                        <i class="fas fa-users text-white-50"> <span class="button-text"> Raters</span></i>
                                    </a>
                                    <a (click)="openConfirmModal()" class="d-none d-sm-inline-block btn btn-sm shadow-sm" [ngClass]="{'btn-red': canDelete, 'btn-gray': !canDelete}">
                                        <i class="fas fa-user-times text-white-50"> <span class="button-text"> Unassign</span></i>
                                    </a>
                                </div>

                                <div *ngIf="currentSelectedTab == 2 || currentSelectedTab == 2.2">

                                    <a id="addTagsAssessments" (click)="openAddTagsAssessmentsModal()" [ngClass]="{'btn-primary': canAddTags, 'btn-gray': !canAddTags}" class="d-none d-sm-inline-block btn btn-sm  shadow-sm margin-right-5">
                                        <i class="fas fa-plus text-white-50"> <span class="button-text"> Add Tags</span></i>
                                    </a>

                                    <a id="archiveAssessments" (click)="openArchiveAssessmentsConfirmationModal()" [ngClass]="{'btn-primary': completedCanArchiveAssessments, 'btn-gray': !completedCanArchiveAssessments}" class="d-none d-sm-inline-block btn btn-sm  shadow-sm margin-right-5">
                                        <i class="fas fa-archive text-white-50"> <span class="button-text"> Archive </span></i>
                                    </a>

                                    <a id="enableResults" (click)="enableClientSeeResults()" [ngClass]="{'btn-other': completedCanEnableResults, 'btn-gray': !completedCanEnableResults}" class="d-none d-sm-inline-block btn btn-sm  shadow-sm margin-right-5">
                                        <i class="fas fa-toggle-on text-white-50"> <span class="button-text"> Enable Results</span></i>
                                    </a>
                                </div>

                                <div *ngIf="currentSelectedTab == 3 || currentSelectedTab == 3.2">

                                    <a id="addTagsAssessments" (click)="openAddTagsAssessmentsModal()" [ngClass]="{'btn-primary': canAddTags, 'btn-gray': !canAddTags}" class="d-none d-sm-inline-block btn btn-sm  shadow-sm margin-right-5">
                                        <i class="fas fa-plus text-white-50"> <span class="button-text"> Add Tags</span></i>
                                    </a>

                                    <a (click)="openExtendModal('expired')" class="d-none d-sm-inline-block btn btn-sm shadow-sm margin-right-5" [ngClass]="{'btn-primary': canUpdate, 'btn-gray': !canUpdate}">
                                        <i class="fas fa-calendar-day text-white-50"> <span class="button-text"> Update</span></i>
                                    </a>
                                    <!--<a (click)="copy()" class="d-none d-sm-inline-block btn btn-sm  shadow-sm margin-right-5" [ngClass]="{'btn-other': canCopy, 'btn-gray': !canCopy}">
                        <i class="fas fa-copy text-white-50"> <span class="button-text"> Copy link</span></i>
                    </a>
                    <a *ngIf="currentSelectedTab == 3.2" (click)="showRatersModal()" class="d-none d-sm-inline-block btn btn-sm shadow-sm margin-right-5" [ngClass]="{'btn-primary': canAddRaters, 'btn-gray': !canAddRaters}">
                        <i class="fas fa-users text-white-50"> <span class="button-text"> Raters</span></i>
                    </a>-->
                                    <a (click)="openConfirmModal()" class="d-none d-sm-inline-block btn btn-sm shadow-sm" [ngClass]="{'btn-red': canDelete, 'btn-gray': !canDelete}">
                                        <i class="fas fa-user-times text-white-50"> <span class="button-text"> Unassign</span></i>
                                    </a>
                                </div>

                                <!--<div>
                    <a (click)="openAssignAssessmentModal()" class="d-none d-sm-inline-block btn btn-sm shadow-sm margin-right-5 btn-other">
                        <i class="fas fa-user-alt text-white-50"> <span class="button-text"> Assign</span></i>
                    </a>
                </div>-->

                                <div *ngIf="currentSelectedTab == 4 || currentSelectedTab == 4.2">
                                    <a id="restoreAssessments" (click)="openRestoreAssessmentsConfirmationModal()" [ngClass]="{'btn-primary': canRestoreAssessments, 'btn-gray': !canRestoreAssessments}" class="d-none d-sm-inline-block btn btn-sm  shadow-sm margin-right-5">
                                        <i class="fas fa-archive text-white-50"> <span class="button-text"> Restore </span></i>
                                    </a>
                                </div>
                            </div>
                        </div>

                        <div class="">
                            <div class="responsiveTabs">
                                <select id="responsiveSelect" #t (change)="openTab(t.value)">
                                    <!--<option value="0-Tab1">Available</option>-->
                                    <option value="1-tab1">Assigned</option>
                                    <option value="2-tab2">Completed</option>
                                    <option value="3-tab3">Expired</option>
                                    <option value="4-tab4">Archived</option>
                                </select>
                            </div>

                            <div class="desktopTabs" style="position: relative;z-index: 0;">
                                <ul class="tab-nav">
                                    <!--<li (click)="tabSelect(0)"><a data-toggle="tab" href="#tab0">Available</a></li>-->
                                    <li (click)="tabSelect(1)" class="active"><a data-toggle="tab" href="#tab1">Assigned</a></li>
                                    <li (click)="tabSelect(2)"><a data-toggle="tab" href="#tab2">Completed</a></li>
                                    <li (click)="tabSelect(3)"><a data-toggle="tab" href="#tab3">Expired</a></li>
                                    <li (click)="tabSelect(4)"><a data-toggle="tab" href="#tab4">Archived</a></li>
                                </ul>
                            </div>

                            <div class="main-tab-content tab-content editClientTabs">
                                <!--<div id="tab0" class="tab-pane fade">

                    <div class="desktopTabs">
                        <ul class="nav nav-tabs">
                            <li id="0" (click)="tabSelect(0)" class="active"><a data-toggle="tab" href="">ELI Self Assessment</a></li>
                            <li id="0.2" (click)="tabSelect(0.2)"><a data-toggle="tab" href="">ELI 360</a></li>
                        </ul>
                    </div>
                </div>-->

                                <div id="tab1" class="tab-pane fade  in active">

                                    <div class="">
                                        <ul class="nav nav-tabs">
                                            <li id="1" (click)="tabSelect(1)" class="active"><a data-toggle="tab" href="">ELI Self Assessment</a></li>
                                            <li id="1.2" (click)="tabSelect(1.2)"><a data-toggle="tab" href="">ELI 360</a></li>
                                        </ul>
                                    </div>
                                </div>

                                <div id="tab2" class="tab-pane fade">
                                    <div class="">
                                        <ul class="nav nav-tabs">
                                            <li id="2" (click)="tabSelect(2)" class="active"><a data-toggle="tab" href="">ELI Self Assessment</a></li>
                                            <li id="2.2" (click)="tabSelect(2.2)"><a data-toggle="tab" href="">ELI 360</a></li>
                                        </ul>
                                    </div>
                                </div>

                                <div id="tab3" class="tab-pane fade">
                                    <div class="">
                                        <ul class="nav nav-tabs">
                                            <li id="3" (click)="tabSelect(3)" class="active"><a data-toggle="tab" href="">ELI Self Assessment</a></li>
                                            <li id="3.2" (click)="tabSelect(3.2)"><a data-toggle="tab" href="">ELI 360</a></li>
                                        </ul>
                                    </div>
                                </div>

                                <div id="tab4" class="tab-pane fade">

                                    <div class="">
                                        <ul class="nav nav-tabs">
                                            <li id="4" (click)="tabSelect(4)" class="active"><a data-toggle="tab" href="">ELI Self Assessment</a></li>
                                            <li id="4.2" (click)="tabSelect(4.2)"><a data-toggle="tab" href="">ELI 360</a></li>
                                        </ul>
                                    </div>
                                </div>

                                <div class="table-responsive" style="width: 100%; max-height: 400px; height:400px;">
                                    <ag-grid-angular #agGrid
                                                     style="width: 100%; height: 100%;"
                                                     class="ag-theme-balham"
                                                     [enableFilter]="true"
                                                     [floatingFilter]="true"
                                                     [gridOptions]="gridOptions"
                                                     [rowData]="data"
                                                     [columnDefs]="dataHeaders"
                                                     [enableSorting]="true"
                                                     [enableColResize]="true"
                                                     (rowClicked)="onRowClicked($event)"
                                                     [rowSelection]="'multiple'"
                                                     (selectionChanged)="onSelectionChanged($event)"
                                                     (gridReady)="onGridReady($event)"
                                                     [pagination]="true"
                                                     [paginationPageSize]="25"
                                                     [overlayNoRowsTemplate]="overlayNoRowsTemplate">
                                    </ag-grid-angular>
                                </div>
                            </div>
                        </div>
                    </ng-template>

                </div>
            </div>
        </div>
        <p id="linkToCopy" style="display:none;"></p>
    </div>
</div>

<!--/*CONFIRMATION DELETE Client MODAL*/-->
<div id="editClientConfirmationDeleteModal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title text-center">Delete Client(s)</h2>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body text-center">
                <p>Are you sure you want to delete this <b>Client</b>?</p>
            </div>

            <div class="modal-footer">
                <div>
                    <div class="col-md-12">
                        <button data-dismiss="modal" type="button" class="btn btn-secondary">No</button>
                        <button (click)="deleteClients()" type="button" class="btn btn-primary">Yes</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--/*extend modal*/-->
<div id="extendModal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog" style="max-width: 470px;margin: 30px auto;" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title text-center">Update Assignment</h2>
                <button type="button" class="close" (click)="closeExtendModal()" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body">
                <div class="row" [ngClass]="{'d-none': fromExpired}">
                    <div class="col-12 col-md-3 text-right" style="padding-right:0px;">
                        <p>Send on:</p>
                    </div>
                    <div class="col-12 col-md-9 schedule">
                        <div class="row">
                            <div class="col-xs-6 col-md-6 noPadding removePaddingOnResponsive">
                                <div>
                                    <!-- NEW DATE PICKER -->
                                <input id="editClientSentDateInput" type="date" [ngStyle]="{'pointer-events': pointerEvents ? 'auto' : 'none' }" [(ngModel)]="sentDate" (change)="onDateSelect(sentDate, 2)">
                                <!-- NEW DATE PICKER -->
                                    <!-- <angular2-date-picker [ngStyle]="{'pointer-events': pointerEvents ? 'auto' : 'none' }" (onDateSelect)="onDateSelect($event, 1)" [(ngModel)]="sentDate" [settings]="settings"></angular2-date-picker> -->
                                </div>
                            </div>
                            <div class="col-xs-6 col-md-6 noPadding removePaddingOnResponsive" style="padding-left: 10px !important;">
                                <div>
                                    <select [ngStyle]="{'pointer-events': pointerEvents ? 'auto' : 'none' }" class="blueSelect" id="manageAssignedUpdateHour">
                                        <option *ngFor="let hour of hours" [value]="hour">{{hour}}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-md-3 text-right" style="padding-right:0px;">
                        <p>Expires on:</p>
                    </div>
                    <div class="col-12 col-md-9 expiration">
                        <div class="row">
                            <div [ngClass]="{'col-md-12': fromExpired, 'col-md-6': !fromExpired }" class="col-6 noPadding">
                                <!-- NEW DATE PICKER -->
                                <input id="expiresDatePicker" type="date" [(ngModel)]="expiresOn" (change)="onDateSelect(expiresOn, 2)" [min]="getTodayDate2()">
                                <!-- NEW DATE PICKER -->
                                <!-- <angular2-date-picker (onDateSelect)="onDateSelect($event, 2)" [(ngModel)]="expiresOn" [settings]="settings"></angular2-date-picker> -->
                            </div>
                        </div>
                        <!--<input id="extendedExpiresIn" type="number" name="text" min="0" />-->
                    </div>
                    <!--<div class="col-xs-3 col-md-2">
                        <span>day(s)</span>
                    </div>-->
                </div>
            </div>

            <div class="modal-footer">
                <div class="row" style="padding-right: 25px;">
                    <div class="col-md-12">
                        <button (click)="closeExtendModal()" type="button" class="btn btn-secondary">Cancel</button>
                        <button (click)="extendExpirationDate()" type="button" class="btn btn-primary">Ok</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--/*CONFIRMATION UNASSIGN MODAL*/-->
<div id="confirmModal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-sm" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title text-center">Assessment</h2>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body text-center">
                <span *ngIf="!inProgress" style="font-size:17px;">Are you sure you want to unassign the selected assessments?</span>
                <img *ngIf="inProgress" src="../../../assets/img/gif/redLoading.gif" width="50" height="50" alt="In progress..." />
                <p *ngIf="inProgress" style="font-size:12px;">Loading...</p>
            </div>

            <div class="modal-footer">
                <div class="row">
                    <div *ngIf="!inProgress" class="col-md-12 text-center">
                        <button data-dismiss="modal" type="button" class="btn btn-secondary">No</button>
                        <button (click)="confirm()" type="button" class="btn btn-primary">Yes</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--/*import modal*/-->
<div id="importRaterModal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title text-center">Import Raters</h2>
                <button type="button" class="close" (click)="closeImportModal()" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body">
                <div *ngIf="importRaterPageIdx == 0" class="row">
                    <div class="col-xs-3 col-sm-2 text-right">
                        <label><b style="color:#000;">File: </b></label>
                    </div>
                    <div class="col-xs-9 col-sm-10" style="display: inline-flex;">
                        <input type="text" class="input_readonly" style="cursor: default !important;" readonly [(ngModel)]="fileName" />
                        <div class="fileUpload btn btn-primary">
                            <span>...</span>
                            <input accept=".csv" (change)="getBlobFile($event)" type="file" class="upload" id="iFile" />
                        </div>
                    </div>
                </div>

                <div *ngIf="importRaterPageIdx == 1" class="row">
                    <div class="page2">
                        <h5>Language and Dates</h5>
                        <div class="row">
                            <div class="col-sm-12 col-md-3">
                                <label>Language: </label>
                            </div>
                            <div class="col-sm-12 col-md-9" style="padding-right: 5px;">
                                <select #importLanguage id="importLanguages">
                                    <option *ngFor="let language of languages" [value]="language.ShortCode">{{language.Name}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="row radios">
                            <div class="col-sm-12 col-md-3 datepicker">
                                <label style="text-align: right;">Schedule for:</label>
                            </div>
                            <div class="col-sm-12 col-md-2" style="padding-right: 5px;" id="importDatapiker">

                                <label class="container">
                                    Now
                                    <input type="radio" checked="checked" name="schedule" value="0">
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                            <div class="col-sm-12 col-md-4 responsiveRadioDiv" style="padding-left: 5px; padding-right: 5px;" id="importDivHour">
                                <label class="container responsiveRadioLabel">
                                    <span style="margin-left:5px;"></span>
                                    <input type="radio" name="schedule" value="1">
                                    <span style="left: 18px;" class="checkmark"></span>
                                </label>
                                <!-- <angular2-date-picker (onDateSelect)="onDateSelect($event)" [(ngModel)]="importDate" [settings]="settings"></angular2-date-picker> -->
                                <input  type="date" [(ngModel)]="importDate" (change)="onDateSelect($event)">
                            </div>
                            <div class="col-sm-12 col-md-3" style="padding-left: 5px; padding-right: 5px;" id="importDivHour">
                                <select (change)="importHourChanged()" class="blueSelect" id="importHour">
                                    <option *ngFor="let hour of hours" [value]="hour">{{hour}}</option>
                                </select>
                            </div>

                        </div>
                        <div class="row">
                            <div class="col-sm-12 col-md-3">
                                <label>Expires in:</label>
                            </div>
                            <div class="col-sm-12 col-md-9">
                                <input id="importExpiresIn" type="number" name="text" value="30" max="30" min="0" />
                                <span>day(s)</span>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <div class="modal-footer">
                <div class="row">
                    <div class="row">
                        <div class="col-md-12">
                            <button *ngIf="importRaterPageIdx == 0" (click)="closeImportModal()" type="button" class="btn btn-secondary">Cancel</button>
                            <button *ngIf="importRaterPageIdx > 0" (click)="importRaterPrev()" type="button" class="btn btn-primary">Previous</button>
                            <button *ngIf="importRaterPageIdx < 1" style="margin-right: 25px;" (click)="importRaterNext()" type="button" class="btn btn-primary">Next</button>
                            <button *ngIf="importRaterPageIdx == 1" style="margin-right: 25px;" (click)="okImportRaters()" type="button" class="btn btn-primary">Finish</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div id="editClientModal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title text-center">Edit Client</h2>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body">
                <div class="row">
                    <div class="col-sm-12 col-md-2 text-right noPadding">
                        <label>Email: </label>
                    </div>
                    <div class="col-sm-12 col-md-10 noPadding">
                        <input email
                               placeholder="Email"
                               #email
                               (keypress)="preventSpace(email.value, $event, 'cemail')"
                               type="email"
                               value=""
                               id="cemail"
                               [(ngModel)]="client.email"
                               [readonly]="client.status != 'Pending Activation'"
                               [ngClass]="{'input_readonly': client.status != 'Pending Activation'}" />
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12 col-md-2 text-right noPadding">
                        <label>First Name: </label>
                    </div>
                    <div class="col-sm-12 col-md-10 noPadding">
                        <input placeholder="First Name"
                               #name
                               (keypress)="preventSpace(name.value, $event, 'cname')"
                               type="text"
                               value=""
                               id="cname"
                               [(ngModel)]="client.firstName" />
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12 col-md-2 text-right noPadding">
                        <label>Last Name: </label>
                    </div>
                    <div class="col-sm-12 col-md-10 noPadding">
                        <input placeholder="Last Name"
                               #last
                               (keypress)="preventSpace(last.value, $event, 'clast')"
                               type="text"
                               value=""
                               id="clast"
                               [(ngModel)]="client.lastName" />
                    </div>
                </div>
            </div>

            <div class="modal-footer">
                <div>
                    <div *ngIf="!inProgress" class="col-md-12 text-right">
                        <button data-dismiss="modal" type="button" class="btn btn-secondary">Cancel</button>
                        <button (click)="updateClient()" type="button" class="btn btn-primary">Save</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--raters Modal-->
<div id="editClientId">
    <app-raters-modal #ratersModal></app-raters-modal>
</div>

<!--QUICK ACTIONS-->
<app-purchase-assessment-modal #purchaseAssessment></app-purchase-assessment-modal>
<app-assign-assessment-modal #assignAssessment></app-assign-assessment-modal>

<!--raters types-->
<app-rater-types-for-modal #raterTypesForModal></app-rater-types-for-modal>

<!-- Archive Assessments confirmation modal -->
<div id="archiveConfirmationModal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title text-center">Archive Assessements</h2>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body text-center">
                <p>Are you sure you want to archive the selected assessments?</p>
            </div>

            <div class="modal-footer">
                <div>
                    <div class="col-md-12">
                        <button *ngIf="!archiving;" type="button" data-dismiss="modal" class="btn btn-secondary">No</button>
                        <button *ngIf="!archiving; else archivingResults;" (click)="archiveAssessments()" type="button" class="btn btn-primary">Yes</button>
                        <ng-template #archivingResults>
                            <button disabled class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm margin-right-5">
                                <i class="fa fa-spinner fa-pulse fa-3x fa-fw" style="font-size:20px;padding:0;position: relative;top:0px;"></i> Archiving
                            </button>
                        </ng-template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- restore Assessments confirmation modal -->
<div id="restoreConfirmationModal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title text-center">Restore Assessements</h2>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body text-center">
                <p>Are you sure you want to restore the selected assessments?</p>
            </div>

            <div class="modal-footer">
                <div>
                    <div class="col-md-12">
                        <button *ngIf="!restoring;" type="button" data-dismiss="modal" class="btn btn-secondary">No</button>
                        <button *ngIf="!restoring; else restoringResults;" (click)="restoreAssessments()" type="button" class="btn btn-primary">Yes</button>
                        <ng-template #restoringResults>
                            <button disabled class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm margin-right-5">
                                <i class="fa fa-spinner fa-pulse fa-3x fa-fw" style="font-size:20px;padding:0;position: relative;top:0px;"></i> Restoring
                            </button>
                        </ng-template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--/*ADD  TAGS modal*/-->
<div id="editClientAddTagsModal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title text-center">Add tags</h2>
                <button (click)="closeAddTagsModal()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body">
                <div class="row container-fluid">
                    <div class="col-xs-2">
                        <span>Tags</span>
                        <i style="margin-left:0;position:relative;top:0;" [popover]="help" class="fas fa-question-circle pointer"></i>
                        <popover-content #help
                                         title="Tags"
                                         placement="right"
                                         [animation]="true"
                                         [closeOnClickOutside]="true">
                            <p>Create or use existing tags and add them to assigned assessments. Tags can be searched on the Managed Assessment page allowing you to view and select assessments based on any grouping you desire. You can learn more about this feature in Tutorial 6.</p>
                        </popover-content>
                    </div>
                    <div class="col-xs-8" style="margin-top: -10px;">
                        <tag-input [(ngModel)]='addTags'
                                   [addOnBlur]="true"
                                   (onRemove)="onItemRemoved($event)"
                                   (onAdd)="onItemAdded($event)"
                                   [secondaryPlaceholder]="placeholder"
                                   [placeholder]="placeholder"
                                   [inputId]="'completedTagsInput'"
                                   (onFocus)="onFocusInput()"
                                   [theme]="'foundation-theme'"></tag-input>
                        <i class="fas fa-search searchIcon" (click)="focusTagsInput('completedTagsInput')"></i>
                    </div>
                    <div class="col-xs-2">
                        <a style="right: 14px; position: absolute; cursor:pointer;text-decoration: underline;" (click)="openTagsModal()">My tags</a>
                    </div>

                </div>
            </div>

            <div class="modal-footer">
                <div>
                    <div class="col-md-12">
                        <button (click)="closeAddTagsModal()" type="button" class="btn btn-secondary">Cancel</button>
                        <button (click)="addAssessmentsTags()" [disabled]="assessmentAddTags.length === 0" type="button" class="btn btn-primary">Ok</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--/*tags modal*/-->
<div id="tagsModal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title text-center">My tags</h2>
                <button (click)="closeTagsModal()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body">

                <div *ngIf="selectedCoachTags.length > 0" class="tags-wrap">
                    <div *ngFor="let tag of selectedCoachTags; let i = index;" class="tag">
                        {{tag.Text}}
                        <span title="Delete" class="animate fadeInRight" (click)="removeTag(i, tag.Text)">&times;</span>
                    </div>
                </div>

                <div *ngIf="selectedCoachTags.length === 0">
                    <input type="text" placeholder="Select tags from the table" id="placeholderInput" readonly />
                </div>

                <div class="table-responsive" style="width: 100%; max-height: 400px; height:400px;">
                    <ag-grid-angular #coachTagsGrid
                                     style="width: 100%; height: 100%;"
                                     class="ag-theme-balham"
                                     [enableFilter]="true"
                                     [gridOptions]="gridOptions"
                                     [rowData]="coachTags"
                                     [columnDefs]="coachTagsHeaders"
                                     (gridReady)="onCoachTagsGridReady($event)"
                                     [enableSorting]="true"
                                     [enableColResize]="true"
                                     [pagination]="true"
                                     [paginationPageSize]="25"
                                     [overlayNoRowsTemplate]="overlayNoRowsTemplate"
                                     (rowClicked)="onCoachTagsRowClicked($event)"
                                     (selectionChanged)="onCoachTagsSelectionChanged($event)">
                    </ag-grid-angular>
                </div>

            </div>

            <div class="modal-footer">
                <div>
                    <div class="col-md-12">
                        <button (click)="closeTagsModal()" type="button" class="btn btn-secondary">Cancel</button>
                        <button (click)="addNewCoachTags()" type="button" class="btn btn-primary">Add</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>